import { IColumnHeader, ITableRow } from '../../../../store/mst/Upload/models';
import { ADDRESS_COLUMN_KEYS } from './getColumnHeaders';

const doesRowHaveAddressData = (row: ITableRow, mappedAddressHeaders: { [key: string]: IColumnHeader }): boolean => ADDRESS_COLUMN_KEYS.some((k) => {
  const matchedIndex = mappedAddressHeaders[k]?.matchedIndex;
  return !!row.cells?.[matchedIndex]?.value;
});

export default doesRowHaveAddressData;
